export const BehaviourResponse = [
  {
    behaviours_name: "Pioneer",
    behaviour_type_name: "(D/ISC) High Dominance",
    behaviour_desctiption: "Pioneers are often ambitious, competitive, and strong-willed individuals. They have a very high need to achieve and continually seek new horizons. Their self-reliance and independent thinking drive them to escape convention and create innovative solutions. They are direct and assertive and apt at influencing people. They are dynamic, adaptable, and willing to do anything to overcome obstacles. Pioneers are persistent in their pursuit of desired results. Overcome by their desire to achieve their goals, they might fail to take other people’s feelings into consideration. Additionally, they have high expectations of others and can be critical if their standards are not met.",
    suvcm: [{ Strengths: "Action-oriented, resourceful, self-reliant, decisive, proactive, strong-willed, direct", Uniqueness: "Sound decision making, self-motivated, excels in emergencies", Value_to_ORG: "Innovative solutions; taking responsibility", Challenges: "Too independent, tends to be blunt, boredom", Motivation: "New opportunities, strong need to achieve, power and structure." }]
  },
  {
    behaviours_name: "Influencer",
    behaviour_type_name: "(I/DSC) High Influence",
    behaviour_desctiption: "Influencers are confident, outgoing and friendly individuals who love to be the center of attention. They seek out situations that involve meeting people and socializing. Their confidence combined with a genuine interest in ideas and people, allows them to interact easily, and positively in almost any situation. These strong communicators are assertive, intuitive, and adaptive. They thrive in meetings, committees, and conferences. They may need a constant dose of Approval. They also might sometimes lose focus on timelines and the tasks at hand.",
    suvcm: [{ Strengths: "Fun, persuasive, ideas-oriented, creative, original, networkers, intuitive", Uniqueness: "Openness, strong communication, social confidence", Value_to_ORG: "Contributing original ideas, improve and extend coordination within team", Challenges: "Needs constant approval, pressured conditions", Motivation: "Being surrounded by people, supportive and collaborative environment" }]
  },
  {
    behaviours_name: "Team Player",
    behaviour_type_name: "(S/DIC) High Steadiness",
    behaviour_desctiption: "Team players are friendly, calm, and thoughtful individuals that like doing practical jobs. Amidst their calm nature, controlled stance, modest attitude, and excellent listening skills, they tend to empathize with others ’perspectives. They value positive interactions and are always willing to help. They depend on more socially assertive people to take the lead. Their persistence and patience enable them to work steadily until the task is completed. They value trust strongly and enjoy being part of a smaller team where they are valued and appreciated. Typically, they resist change and need help in developing alternative solutions.",
    suvcm: [{ Strengths: "Flexibility, dependability, harmony, warmth, listening, team-focused, loyal", Uniqueness: "Listens effectively, supportive, works steadily", Value_to_ORG: "Capable of dealing with laborious tasks; works on a task until it is achieved", Challenges: "Sudden change; interruptions and distractions", Motivation: "Helping others succeed; support of people; doing practical jobs" }]
  },
  {
    behaviours_name: "Logical Thinker",
    behaviour_type_name: "(C/DIS) High Compliance",
    behaviour_desctiption: "Logical thinkers are hardworking, logical, and detail-oriented individuals with high critical thinking abilities. Their habit of meticulous preparation, accuracy, and correctness helps them to manage tasks effectively. Despite being shy and mild-mannered, logical thinkers have a strong need to control their environment. They exert rules, structure, and standards, to accomplish their goals, in conflicting situations. Their cautiousness makes them reluctant to reveal information about themselves or their thoughts unless necessary. Being natural risk avoiders, they only undertake tasks when they are completely certain about the outcome.",
    suvcm: [{ Strengths: "Quality control, handling detail, analyzing data, logical, avoiding the risk, building structure, being deliberate and methodical", Uniqueness: "Accuracy; ability to think logically; building structure", Value_to_ORG: "Completes the undertaken task; great at quality control; organizing information", Challenges: "Spotting deficiencies first; controlling; lacks assertiveness", Motivation: "Certainty of situation and consequences; getting things right" }]
  },
  {
    behaviours_name: "Persuader",
    behaviour_type_name: "(DI/SC) High Dominance and Influence",
    behaviour_desctiption: "Persuaders are assertive, adventurous, and confident individuals with strong social skills. They can be charming or demanding, based on the circumstances. They tend to approach people and situations with energy. While communicating, they can be both assertive and persuasive. Their ability to think and react quickly lets them easily adapt to challenging situations. They have no fear of confrontation and address issues directly. They have clear goals in life and achieve them with sheer determination and commitment. Persuaders thrive in situations that others would find impossibly stressful and difficult. They live for and are happiest when on adventures",
    suvcm: [{ Strengths: "Charming, visionary, adventurous, bold, high energy, results-focused, exciting and fun", Uniqueness: "Sound decision making, self-motivated, excels in emergencies", Value_to_ORG: "Thrives under pressure; motivates people; commits and achieves results", Challenges: "Stagnation; can get aggressive under pressure", Motivation: "Success and recognition; new experiences and challenges" }]
  },
  {
    behaviours_name: "Achiever",
    behaviour_type_name: "(DS/IC) High Dominance and Steadiness",
    behaviour_desctiption: "This is an extremely rare profile with radically different sets of values and motivations. Achievers are reliable, persistent, tenacious, and industrious individuals with a strong sense of personal accountability. They like to get things done in a friendly but thorough manner. They are focused on results with a strong inclination towards fair play and respect. Their careful planning allows them to complete tasks within realistic timescales. They tend to be thoughtful in favorable conditions and demanding at times of pressure. Achievers are usually cautious and only open up to a small set of people they completely trust. They function at peak efficiency and expect recognition equal to their contribution.",
    suvcm: [{ Strengths: "Patient, tenacious, dependable, consistent, protective, kind, watchful", Uniqueness: "Methodical in approach; accountability of work", Value_to_ORG: "Self-driven and completes tasks effectively", Challenges: "Poor communication; inferior work", Motivation: "Personal and professional accomplishments" }]
  },
  {
    behaviours_name: "Perfectionist",
    behaviour_type_name: "(DC/IS) High Dominance and Compliance",
    behaviour_desctiption: "Perfectionists are tenacious, competitive, systematic, and creative individuals with opposing behavioral forces. They seek immediate results and have an equally strong desire for perfection. Their ability to plan and achieve quality allows them to make sound decisions. They think and act quickly but also evaluate all options before agreeing to a course of action. In their drive for results and perfection, they demand the freedom to explore and the authority to examine. They are straightforward and enjoy working by themselves. They tend to be careful with relationships and prefer a strategic approach when dealing with others. They are open to change but extremely cautious.",
    suvcm: [{ Strengths: "Tenacity, quality control, handling large amounts of detail, analyzing data, building systems, competing to win, results-focused, striving to be the best", Uniqueness: "Attention to detail; tries innovative approaches using existing systems", Value_to_ORG: "Can bring positive change to the team by challenging them and raising the standards", Challenges: "Bored with routine work; gets lost in detail", Motivation: "Unique accomplishments and dominance" }]
  },
  {
    behaviours_name: "Assessor",
    behaviour_type_name: "(IC/DS) High Influence and Compliance",
    behaviour_desctiption: "Assessors are articulate, creative, organized, and well-researched individuals with a unique blend of contradicting traits. They seek the company of others but are also exhausted by them. On one hand, they are outgoing and impulsive in favorable conditions yet in formal situations, they are precise and rule-abiding. They are naturally skilled at influencing people with strong communication. They are imaginative, perceptive and strive for perfection. They elicit cooperation from others by being considerate. They have the desire to win and can overwork to the point of exhaustion. They are practical and ensure progressive results by developing a detailed plan of action.",
    suvcm: [{ Strengths: "Articulate, well-researched, produce quality results, self-disciplined, careful, expressive, enthusiastic, fun", Uniqueness: "Turning dreams into workable concepts; result-oriented and quality-driven", Value_to_ORG: "Brings new ideas to the table; team players that instigate action and activities", Challenges: "Not knowing when to stop; sensitive to criticism", Motivation: "Winning attention and approval; succeeding at all costs" }]
  },
  {
    behaviours_name: "Implementor",
    behaviour_type_name: "(SC/DI) High Steadiness and Compliance",
    behaviour_desctiption: "Implementors are stable, consistent, pragmatic, and accommodating individuals that are driven by patience, accuracy, and logic. They are precise thinkers and through precautions avoid the unexpected. They prefer traditional approaches. They question assumptions and require loads of information that they can analyze when exploring alternatives and before reaching conclusion. They enjoy overcoming challenges through persistence and intense focus. They are calm and rational folks, and they rarely provide input in a group.They hold themselves to high standards and desire to earn the respect of those around them.",
    suvcm: [{ Strengths: "Dependable, stable, careful, accurate, hard working, patient, diplomatic", Uniqueness: "Brings stability on board; sticks to “fail safe” options", Value_to_ORG: "Works diligently to get the job done; maintains quality and standards", Challenges: "Reluctant to change; takes time to adapt", Motivation: "Predictable and stable outcomes; recognition for work" }]
  },
  {
    behaviours_name: "Motivator",
    behaviour_type_name: "(DIS/C) High Dominance, Influence and Steadiness",
    behaviour_desctiption: "This is an extremely rare profile with radically different sets of values and motivations. Achievers are reliable, persistent, tenacious, and industrious individuals with a strong sense of personal accountability. They like to get things done in a friendly but thorough manner. They are focused on results with a strong inclination towards fair play and respect. Their careful planning allows them to complete tasks within realistic timescales. They tend to be thoughtful in favorable conditions and demanding at times of pressure. Achievers are usually cautious and only open up to a small set of people they completely trust. They function at peak efficiency and expect recognition equal to their contribution.",
    suvcm: [{ Strengths: "Dependable, socially skilled, patient, warm, interesting and fun, driven to achieve, self-reliant", Uniqueness: "Clarity on goals and ways to accomplish; control over circumstances", Value_to_ORG: "Confidently suggests innovative ideas; assigns tasks effectively", Challenges: "Being asked to investigate too much detail; routine and regimen", Motivation: "New opportunities; strong need to achieve" }]
  },
  {
    behaviours_name: "Mediator",
    behaviour_type_name: "(ISC/D) High Influence, Steadiness and Compliance",
    behaviour_desctiption: "Mediators are creative, well-spoken, and understanding individuals that enjoy being a team member and helping others succeed. They love being in a supportive role and can bring valuable insights if given the time needed to think. They are rational in problem-solving and adept at presenting arguments in a credible manner. Their insistence on taking things at their own pace might not be agreeable to all. They prefer a cooperative environment where people are trustworthy and pleasant. They thrive on their contribution to projects that require attention to detail. They have high expectations of themselves and others around them and might voice disapproval when their expectations are not met.",
    suvcm: [{ Strengths: "Productive, well-spoken, researching, harmonious, collaborative, co-operative, detail-oriented, patient", Uniqueness: "Accommodating and inspiring", Value_to_ORG: "Skilled and proficient in problem solving; highly skilled", Challenges: "Aversion to risks and being too predictable; not recognized as experts.", Motivation: "Supporting and interacting with others; learning from and teaching to others." }]
  },
  {
    behaviours_name: "Collaborator",
    behaviour_type_name: "(IS/DC) High Influence and Steadiness",
    behaviour_desctiption: "Collaborators are warm, empathetic, easygoing and relaxed individuals that socialize with ease. They tend to think of others first over themselves. They strive to maintain harmony and build long-term relationships. Being good listeners, they make others feel heard and offer suggestions gently. They are sympathetic in nature and fulfil supportive roles well. They often provide recognition to others and attribute less importance to task accomplishment. They love to work in team settings and appreciate environments that ensure stability with minimal change. While they generally avoid conflict and confrontation, they are willing to mediate with others to restore harmony.",
    suvcm: [{ Strengths: "Versatile, warm, responsive, upbeat, respectful, loyal, enthusiastic", Uniqueness: "Group acceptance and approval; friendliness", Value_to_ORG: "Effective listening skills; bring stability and harmony to the team", Challenges: "Conflicting situations; over-commitment; boredom; cannot confront or give direct orders.", Motivation: "Recognition from people around; peaceful environment where they can collaborate with others" }]
  },
  {
    behaviours_name: "Administrator",
    behaviour_type_name: "(DSC/I) High Dominance, Steadiness and Compliance",
    behaviour_desctiption: "Administrators are steady, objective, clear-minded and analytical individuals that get results and keep the team happy at the same time. They have a clear view of their aims in life. Their patience and thoughtfulness help them avoid risks. They guard their thoughts and reveal them only after careful thought and consideration. They choose their words carefully, make practical decisions, and rely upon logic rather than emotion. They possess the drive to track detail and the desire to build the harmony needed to run the team. While being good executors, they rarely bring in the imagination and vision needed for innovative initiatives.They can be both dominant and supportive based on the situation.",
    suvcm: [{ Strengths: "Productive, efficient, practical, pragmatic, thoughtful, detail-oriented, patient", Uniqueness: "Uses logic effectively to get results", Value_to_ORG: "Works with determination; can work individually or with others", Challenges: "Tendency to get overworked; being blunt; not creative", Motivation: "Achieving results by taking time to adapt to changing situations; attention to detail; avoiding risk" }]
  },
  {
    behaviours_name: "Leader",
    behaviour_type_name: "(DIC/S) High Dominance, Influence and Compliance",
    behaviour_desctiption: "Leaders are practical, innovative, self-reliant, and ambitious individuals that are always pushing to makethings better. They are friendly, charming, and enthusiastic in casual circumstances but tend to be direct,forthright, and assertive in formal setups. They like taking responsibility and taking credit for both wins and losses, as long as they have control of the results. They do not shy away from taking command when needed and may be impatient with the inefficiencies of others. They are sensitive to the needs of the team. They find a balance between personal ambitions and group goals. They are very clear thinkers, make good decisions and promote harmony in the team.",
    suvcm: [{ Strengths: "Driven, innovative, practical, self-reliant, leadership ability, confident, clear thinking", Uniqueness: "Accommodating and inspiring; drive to make things better", Value_to_ORG: "Persistently accomplishes goals with inclusivity of team", Challenges: "Impatience when things don’t go a certain way; being managed", Motivation: "Opportunity to get things done in their way; supporting the team" }]
  },
]

export const HindiQuizOption = {
  "Enthusiasm": "उत्साही",
  "Daring": "साहसी",
  "Diplomatic": "व्यवहार-कुशल",
  "Satisfied": "संतुष्ट",
  "Cautious": "सजग",
  "Determined": "दृढ़निश्चयी",
  "Convincing": "प्रभावकारी",
  "Good-Natured": "सहृदय",
  "Friendly": "मैत्रीपूर्ण",
  "Accurate": "सटीक",
  "Outspoken": "स्पष्टवादी",
  "Calm": "शांत",
  "Talkative": "बातूनी",
  "Controlled": "संयमित",
  "Conventional": "पारंपरिक",
  "Decisive": "निर्णायक",
  "Adventurous": "साहसिक",
  "Insightful": "कुशाग्र",
  "Outgoing": "खुशमिजाज",
  "Moderate": "तटस्थ",
  "Gentle": "विनीत",
  "Persuasive": "प्रेरक",
  "Humble": "विनम्र",
  "Original": "मौलिक",
  "Expressive": "भावनापूर्ण",
  "Meticulous": "सतर्क",
  "Dominant": "प्रभावशाली",
  "Responsive": "प्रतिक्रियाशील",
  "Poised": "संतुलित",
  "Observant": "चौकस",
  "Modest": "नम्र",
  "Impatient": "अधीर",
  "Tactful": "चातुर्यपूर्ण",
  "Agreeable": "सम्मत",
  "Magnetic": "आकर्षक",
  "Insistent": "आग्रही",
  "Brave": "दिलेर",
  "Inspiring": "प्रेरणादायक",
  "Submissive": "आज्ञापालक",
  "Timid": "भीरू",
  "Reserved": "संकोची",
  "Obliging": "उपकारी",
  "Strong Willed": "दृढ़ संकल्पित",
  "Cheerful": "हंसमुख",
  "Stimulating": "स्फूर्तिवान",
  "Kind": "दयालु",
  "Perceptive": "विचार-कुशल",
  "Independent": "स्वतंत्र",
  "Competitive": "प्रतिस्पर्धात्मक",
  "Considerate": "विचारशील",
  "Joyful": "आनंदपूर्ण",
  "Private": "एकांतप्रिय",
  "Fussy": "अस्त-व्यस्त",
  "Obedient": "आज्ञाकारी",
  "Firm": "अटल",
  "Playful": "चंचल",
  "Attractive": "लुभावना",
  "Introspective": "आत्मविश्लेषी",
  "Stubborn": "जिद्दी",
  "Predictable": "पूर्वाभासी",
  "Logical": "तार्किक",
  "Bold": "बिंदास",
  "Loyal": "निष्ठावान",
  "Charming": "मोहक",
  "Sociable": "सामाजिक",
  "Patient": "सहनशील",
  "Self Reliant": "आत्मनिर्भर",
  "Soft Spoken": "मधुरभाषी",
  "Willing": "राज़ी",
  "Eager": "आतुर",
  "Thorough": "संपूर्ण",
  "High Spirited": "बेहद उत्साही",
  "Aggressive": "आक्रामक",
  "Extroverted": "बहिर्मुखी",
  "Amiable": "स्नेही",
  "Fearful": "भयग्रस्त",
  "Confident": "आत्मविश्वासी",
  "Sympathetic": "सहानुभूतिशील",
  "Impartial": "निष्पक्ष",
  "Assertive": "निश्चयात्मक",
  "Well-Disciplined": "अनुशासित",
  "Generous": "उदार",
  "Animated": "जीवंत",
  "Persistent": "लगनशील",
  "Impulsive": "आवेगशील",
  "Introverted": "अंतर्मुखी",
  "Forceful": "सशक्त",
  "Easy_Going": "सहज",
  "Good-Mixer": "मिलनसार",
  "Refined": "सभ्य",
  "Vigorous": "ओजपूर्ण",
  "Lenient": "मृदुल",
  "Captivating": "मनमोहक",
  "Contented": "संतोषी",
  "Demanding": "अभिलाषी",
  "Compliant": "अनुपालक",
  "Argumentative": "विवादप्रिय",
  "Systematic": "व्यवस्थित",
  "Cooperative": "सहयोगी",
  "Light-Hearted": "प्रसन्नचित्त",
  "Jovial": "हसमुख",
  "Precise": "निश्चित",
  "Direct": "सुस्पष्ट",
  "Even_Tempered": "शांतमिज़ाज",
  "Restless": "बेचैन",
  "Neighbourly": "मित्रतापूर्ण",
  "Appealing": "दिलचस्प",
  "Careful": "सचेत",
  "Respectful": "शिष्ट",
  "Pioneering": "पथप्रदर्शक",
  "Optimistic": "आशावादी",
  "Helpful": "मददगार"
};

export const GujratiQuizOption = {
  "Enthusiasm": "ઉત્સાહી",
  "Daring": "હિંમતવાન",
  "Diplomatic": "કૂટનીતિક",
  "Satisfied": "સંતુષ્ટ",
  "Cautious": "સાવધ",
  "Determined": "અડગ",
  "Convincing": "પ્રભાવી",
  "Good-Natured": "સારા સ્વભાવનું",
  "Friendly": "મૈત્રીપૂર્ણ",
  "Accurate": "સચોટ",
  "Outspoken": "સ્પષ્ટવક્તા",
  "Calm": "શાંત",
  "Talkative": "વાચાળ",
  "Controlled": "નિયંત્રિત",
  "Conventional": "રૂઢિગત",
  "Decisive": "નિર્ણાયક",
  "Adventurous": "સાહસિક",
  "Insightful": "આંતરદૃષ્ટિપૂર્ણ",
  "Outgoing": "મિલનસાર",
  "Moderate": "સંતુલિત",
  "Gentle": "સૌમ્ય",
  "Persuasive": "પ્રેરક",
  "Humble": "નમ્ર",
  "Original": "મૌલિક",
  "Expressive": "અભિવ્યક્ત",
  "Meticulous": "ચોકસાઈપૂર્ણ",
  "Dominant": "પ્રબળ",
  "Responsive": "પ્રતિભાવશીલ",
  "Poised": "સંયમી",
  "Observant": "નિરીક્ષણશીલ",
  "Impatient": "અધીર",
  "Tactful": "સંવેદનશીલ",
  "Agreeable": "સમજોતા",
  "Magnetic": "મોહક",
  "Insistent": "આગ્રહી",
  "Brave": "બહાદુર",
  "Inspiring": "પ્રેરણાદાયી",
  "Submissive": "આજ્ઞાંકિત",
  "Timid": "ડરપોક",
  "Reserved": "સંકોચશીલ",
  "Obliging": "સહાયકારી",
  "Strong Willed": "પ્રબળ ઈચ્છાશક્તિવાળું",
  "Cheerful": "ખુશખુશાલ",
  "Stimulating": "ઉત્તેજક",
  "Kind": "દયાળુ",
  "Perceptive": "દ્રષ્ટિશક્તિશાળી",
  "Independent": "સ્વતંત્ર",
  "Competitive": "સ્પર્ધાત્મક",
  "Considerate": "વિચારવંત",
  "Private": "ખાનગી",
  "Fussy": "મિથ્યાડંબરયુક્ત",
  "Obedient": "આજ્ઞાકારી",
  "Firm": "દ્રઢ",
  "Playful": "રમતિયાળ",
  "Attractive": "આકર્ષક",
  "Introspective": "આત્મનિરીક્ષણાત્મક",
  "Stubborn": "હઠીલું",
  "Predictable": "અનુમાનિત",
  "Logical": "તાર્કિક",
  "Loyal": "વફાદાર",
  "Charming": "આકર્ષણભર્યું",
  "Sociable": "સંબંધકુશળ",
  "Patient": "ધૈર્યવાન",
  "Self Reliant": "આત્મનિર્ભર",
  "Soft Spoken": "મૃદુભાષી",
  "Willing": "ઇચ્છુક",
  "Eager": "આતુર",
  "Thorough": "વિશદ",
  "High Spirited": "ઉત્સાહિત",
  "Aggressive": "આક્રમક",
  "Extroverted": "બહિર્મુખી",
  "Amiable": "સૌહાર્દપૂર્ણ",
  "Fearful": "ભયભીત",
  "Confident": "આત્મવિશ્વાસુ",
  "Sympathetic": "સહાનુભૂતિપૂર્ણ",
  "Impartial": "નિષ્પક્ષ",
  "Assertive": "સાગ્રહી",
  "Well-Disciplined": "શિસ્તબદ્ધ",
  "Generous": "ઉદાર",
  "Animated": "પ્રફુલ્લિત",
  "Persistent": "અટલ",
  "Impulsive": "ઉતાવળો",
  "Introverted": "અંતર્મુખી",
  "Forceful": "બળવાન",
  "Easy Going": "સહજ",
  "Refined": "સંસ્કારિત",
  "Vigorous": "જોશીલું",
  "Lenient": "લચીલો",
  "Captivating": "મનમોહક",
  "Contented": "સંતોષી",
  "Demanding": "અપેક્ષાયુક્ત",
  "Compliant": "અનુરૂપ",
  "Argumentative": "દલીલબાજ",
  "Systematic": "વ્યવસ્થિત",
  "Cooperative": "સહકારી",
  "Light-Hearted": "ખુશમિજાજ",
  "Jovial": "આનંદી",
  "Precise": "ચોક્કસ",
  "Direct": "પ્રત્યક્ષ",
  "Even-Tempered": "સમ-સ્વભાવી",
  "Restless": "બેચેન",
  "Neighbourly": "સદભાવયુક્ત",
  "Appealing": "આકર્ષણજનક",
  "Careful": "કાળજીપૂર્ણ",
  "Respectful": "સંમાનીય",
  "Pioneering": "પથપ્રદર્શક",
  "Optimistic": "આશાવાદી",
  "Helpful": "મદદરૂપ"
}

export const KannadaQuizOption = {
  "Enthusiasm": "ಉತ್ಸಾಹಿ",
  "Daring": "ಧೈರ್ಯವಂತ",
  "Diplomatic": "ರಾಜತಾಂತ್ರಿಕ",
  "Satisfied": "ತೃಪ್ತ",
  "Cautious": "ಎಚ್ಚರಿಕೆಯುಳ್ಳ",
  "Determined": "ನಿಶ್ಚಯಿತ",
  "Convincing": "ಮನವೊಲಿಸುವವ",
  "Good-Natured": "ಒಳ್ಳೆಯ ಸ್ವಭಾವದವ",
  "Friendly": "ಸ್ನೇಹಪರ",
  "Accurate": "ನಿಖರ",
  "Outspoken": "ಮುಕ್ತ ಮಾತುಗಾರ",
  "Calm": "ಶಾಂತ",
  "Talkative": "ವಾಚಾಳಿ",
  "Controlled": "ನಿಯಂತ್ರಿತ",
  "Conventional": "ಪರಂಪರಾಗತ",
  "Decisive": "ತೀರ್ಮಾನಿಸುವವ",
  "Adventurous": "ಸಾಹಸಿ",
  "Insightful": "ಒಳನೋಟವುಳ್ಳ",
  "Outgoing": "ಬಹಿರ್ಗಾಮಿ",
  "Moderate": "ಮಿತವಾದಿ",
  "Gentle": "ಸೌಮ್ಯ",
  "Persuasive": "ಒಪ್ಪಿಸಬಲ್ಲ",
  "Humble": "ವಿನೀತ",
  "Original": "ಮೂಲ",
  "Expressive": "ಅಭಿವ್ಯಕ್ತಿಶೀಲ",
  "Meticulous": "ಸೂಕ್ಷ್ಮ",
  "Dominant": "ಪ್ರಭಾವಶಾಲಿ",
  "Responsive": "ಪ್ರತಿಸ್ಪಂದಕ",
  "Poised": "ಸಮಚಿತ್ತದವ",
  "Observant": "ಪರ್ಯಾವೇಕ್ಷಕ",
  "Modest": "ಆಡಂಬರವಿಲ್ಲದವ",
  "Impatient": "ತಾಳ್ಮೆಯಿಲ್ಲದ",
  "Tactful": "ಚಾತುರ್ಯಯುತ",
  "Agreeable": "ಒಪ್ಪಬಲ್ಲ",
  "Magnetic": "ಆಕರ್ಷಿಸುವವ",
  "Insistent": "ಒತ್ತಾಯ ಮಾಡುವವ",
  "Brave": "ಧೈರ್ಯಶಾಲಿ",
  "Inspiring": "ಸ್ಪೂರ್ತಿದಾಯಕ",
  "Submissive": "ವಿಧೇಯ",
  "Timid": "ಅಂಜುಬುರುಕ",
  "Reserved": "ಮೀಸಲಾಗಿರುವವ",
  "Obliging": "ಉಪಕಾರಶೀಲ",
  "Strong Willed": "ಬಲವಾದ ಇಚ್ಛಾಶಕ್ತಿಯುಳ್ಳ",
  "Cheerful": "ಹಸನ್ಮುಖ",
  "Stimulating": "ಉತ್ತೇಜಿಸುವ",
  "Kind": "ಕರುಣಾಳು",
  "Perceptive": "ಗ್ರಹಿಕೆಯುಳ್ಳ",
  "Independent": "ಸ್ವತ೦ತ್ರ",
  "Competitive": "ಸ್ಪರ್ಧಾತ್ಮಕ",
  "Considerate": "ವಿವೇಚನಾಶೀಲ",
  "Joyful": "ಹರ್ಷಚಿತ್ತ",
  "Private": "ಖಾಸಗಿ",
  "Fussy": "ಚಡಪಡಿಸುವ",
  "Obedient": "ಆಜ್ಞಾಧಾರಕ",
  "Firm": "ದೃಢ",
  "Playful": "ವಿನೋದಪೂರ್ಣ",
  "Attractive": "ಆಕರ್ಷಕ",
  "Introspective": "ಆತ್ಮಾವಲೋಕನ ಮಾಡುವವ",
  "Stubborn": "ಹಠಮಾರಿ",
  "Predictable": "ನಿರೀಕ್ಷಿತ",
  "Logical": "ತಾರ್ಕಿಕ",
  "Bold": "ದಿಟ್ಟ",
  "Loyal": "ನಿಷ್ಠಾವಂತ",
  "Charming": "ಮೋಹಕ",
  "Sociable": "ಸಂಗಶೀಲ",
  "Patient": "ತಾಳ್ಮೆಯುಳ್ಳ",
  "Self Reliant": "ಸ್ವಾವಲಂಬಿ",
  "Soft Spoken": "ಮೃದುವಾಗಿ ಮಾತನಾಡುವವ",
  "Willing": "ಸಿದ್ಧ",
  "Eager": "ಉತ್ಸುಕ",
  "Thorough": "ಸಮಗ್ರ",
  "High Spirited": "ಅತ್ಯುತ್ಸಾಹಿ",
  "Aggressive": "ಆಕ್ರಮಣಕಾರಿ",
  "Extroverted": "ಬಹಿರ್ಮುಖಿ",
  "Amiable": "ಸುಶೀಲ",
  "Fearful": "ಭಯಭೀತನಾದ",
  "Confident": "ಆತ್ಮವಿಶ್ವಾಸಿ",
  "Sympathetic": "ಸಹಾನುಭೂತಿ ಹೊಂದಿರುವವ",
  "Impartial": "ನಿಷ್ಪಕ್ಷಪಾತಿ",
  "Assertive": "ಪ್ರತಿಪಾದಿಸುವ",
  "Well-Disciplined": "ಉತ್ತಮ ಶಿಸ್ತಿನ",
  "Generous": "ಉದಾರ",
  "Animated": "ಲವಲವಿಕೆಯ",
  "Persistent": "ಪಟ್ಟುಬಿಡದ",
  "Impulsive": "ಹಠಾತ್ ಪ್ರವೃತ್ತಿಯವ",
  "Introverted": "ಅಂತರ್ಮುಖಿ",
  "Forceful": "ಬಲವಂತ",
  "Easy Going": "ಸುಲಭವಾಗಿ ಹೋಗುವವ",
  "Good Mixer": "ಉತ್ತಮವಾಗಿ ಬೆರೆಯುವವ",
  "Refined": "ಸುಸಂಸ್ಕೃತ",
  "Vigorous": "ಹುರುಪಿನ",
  "Lenient": "ಸಹಿಷ್ಣು",
  "Captivating": "ಮನಸೆಳೆಯುವ",
  "Contented": "ಸಂತೃಪ್ತ",
  "Demanding": "ಬೇಡಿಕೆಯ",
  "Compliant": "ಅನುಸರಣಾಶೀಲ",
  "Argumentative": "ವಿವಾದಶೀಲ",
  "Systematic": "ವ್ಯವಸ್ಥಿತ",
  "Cooperative": "ಸಹಕಾರಿ",
  "Light-Hearted": "ನಿರಾತಂಕ",
  "Jovial": "ಉಲ್ಲಾಸಶೀಲ",
  "Precise": "ಸ್ಫುಟ",
  "Direct": "ನೇರ",
  "Even-Tempered": "ಸಮಸ್ಥಿತಿಯಲ್ಲಿರುವವನು",
  "Restless": "ವಿಶ್ರಾಂತಿಯಿಲ್ಲದ",
  "Neighbourly": "ನೆರೆಹೊರೆಯ",
  "Appealing": "ಮೋಡಿಮಾಡುವ",
  "Careful": "ಜಾಗರೂಕ",
  "Respectful": "ಗೌರವಯುತ",
  "Pioneering": "ಪ್ರವರ್ತಕ",
  "Optimistic": "ಆಶಾವಾದಿ",
  "Helpful": "ಸಹಾಯಕ"
}

export const TamilQuizOption = {
  "Enthusiasm": "ஆர்வமிக்க",
  "Daring": "துணிவுள்ள",
  "Diplomatic": "ராஜதந்திரமான",
  "Satisfied": "திருப்தியுடன்",
  "Cautious": "எச்சரிக்கையாயிருப்பது",
  "Determined": "உறுதியாக இருப்பது",
  "Convincing": "நம்பவைக்கும்",
  "Good-Natured": "நல்லியல்பான",
  "Friendly": "தோழமையான",
  "Accurate": "துல்லியமாக",
  "Outspoken": "வெளிப்படையாக பேசும்",
  "Calm": "அமைதியாக",
  "Talkative": "வாயாடி",
  "Controlled": "கட்டுப்பாடான",
  "Conventional": "பாரம்பரியமான",
  "Decisive": "தீர்க்கமான",
  "Adventurous": "சாகசமான",
  "Insightful": "நுண்ணறிவுடன்",
  "Outgoing": "வெளிச்செல்லும்",
  "Moderate": "மிதமாக",
  "Gentle": "கனிவாக",
  "Persuasive": "வற்புறுத்தும்",
  "Humble": "பணிவன்புடன்",
  "Original": "அசல்",
  "Expressive": "உணர்ச்சியை வெளிப்படுத்தக்கூடிய",
  "Meticulous": "நுணுக்கமான கவனத்துடன்",
  "Dominant": "ஆதிக்கத்துடன்",
  "Responsive": "பதிலளிக்கக்கூடிய",
  "Poised": "கம்பீரமாக",
  "Observant": "கூர்ந்து கவனித்தல்",
  "Modest": "அடக்கமான",
  "Impatient": "பொறுமையற்ற",
  "Tactful": "சாதுர்யமிக்க",
  "Agreeable": "ஒத்துக்கொள்ளக்கூடியது",
  "Magnetic": "கவரும்படி",
  "Insistent": "வலியுறுத்துவது",
  "Brave": "தைரியமான",
  "Inspiring": "ஊக்கமளிப்பது",
  "Submissive": "அடிபணிந்தவர்",
  "Timid": "தயங்கிய",
  "Reserved": "ஒதுக்கப்பட்ட",
  "Obliging": "உதவும் பண்புடன்",
  "Strong Willed": "வலுவான விருப்பமுள்ள",
  "Cheerful": "மகிழ்ச்சியான",
  "Stimulating": "தூண்டும்படியாக",
  "Kind": "கருணைமிக்க",
  "Perceptive": "பகுத்தறிவுடைய",
  "Independent": "தனித்தியங்கும்படியான",
  "Competitive": "போட்டியாளியான",
  "Considerate": "அக்கறை",
  "Joyful": "மகிழ்வுடன்",
  "Private": "தனியார்",
  "Fussy": "படபடப்பாக",
  "Obedient": "கீழ்ப்படிந்து",
  "Firm": "உறுதியாக",
  "Playful": "விளையாட்டுத்தனமாக",
  "Attractive": "கவர்ச்சிகரமான",
  "Introspective": "சுயபரிசோதனை",
  "Stubborn": "பிடிவாதமான",
  "Predictable": "கணிக்கக்கூடிய",
  "Logical": "தர்க்கரீதியாக",
  "Bold": "துணிவுடன்",
  "Loyal": "விசுவாசத்துடன்",
  "Charming": "வசீகரமாக",
  "Sociable": "நேசமான",
  "Patient": "பொறுமை",
  "Self Reliant": "தற்சார்புடன்",
  "Soft Spoken": "மென்மையான-பேச்சு",
  "Willing": "ஏற்கட் தயாராக",
  "Eager": "ஆவல்",
  "Thorough": "நிறைவாக",
  "High Spirited": "மிகவும் உற்சாகமாக",
  "Aggressive": "ஆக்ரோஷத்துடன்",
  "Extroverted": "புறம்போக்கு",
  "Amiable": "ஒத்துப்போவது",
  "Fearful": "பயத்துடன்",
  "Confident": "நம்பிக்கை",
  "Sympathetic": "அனுதாபம்",
  "Impartial": "பாரபட்சமற்ற",
  "Assertive": "உறுதியான",
  "Well-Disciplined": "ஒழுக்கத்துடன்",
  "Generous": "தாராள மனப்பான்மை",
  "Animated": "அனிமேஷன்",
  "Persistent": "பிடிவாதத்துடன்",
  "Impulsive": "மனக்கிளர்ச்சி",
  "Introverted": "உள்முகமாக",
  "Forceful": "வலுக்கட்டாயப்படுத்துதல்",
  "Easy Going": "ஈஸி கோயிங்",
  "Good Mixer": "இனிமையாக பழகுபவர்",
  "Refined": "மேம்படுத்தப்பட்ட",
  "Vigorous": "அதிதீவிர",
  "Lenient": "லெனியண்ட்",
  "Captivating": "வசப்படுத்தல்",
  "Contented": "மனநிறைவுடன்",
  "Demanding": "கோரிக்கை",
  "Compliant": "இணக்கத்துடன்",
  "Argumentative": "வாதாடும்விதமாக",
  "Systematic": "முறைப்படி",
  "Cooperative": "ஒத்துழைப்பு",
  "Light-Hearted": "களிப்பான மனதுடன்",
  "Jovial": "வேடிக்கையாக",
  "Precise": "துல்லியமான",
  "Direct": "நேரடி",
  "Even-Tempered": "சாந்தமாக",
  "Restless": "பதற்றமாக",
  "Neighbourly": "அண்டைநாட்டு மனப்பான்மையுடைய",
  "Appealing": "கவர்ந்திழுக்கக்கூடிய",
  "Careful": "கவனத்துடன்",
  "Respectful": "மரியாதைக்குகந்த",
  "Pioneering": "முன்னோடி",
  "Optimistic": "நற்சிந்தனையுடன்",
  "Helpful": "உதவிகரமாக"
}

export const TeluguQuizOption = {
  "Enthusiasm": "ఉత్సుకత గలవాడు",
  "Daring": "సాహసవంతుడు",
  "Diplomatic": "కూటనీతిజ్ఞ",
  "Satisfied": "తృప్తి కలిగిన వాడు",
  "Cautious": "జాగ్రతపరుడు",
  "Determined": "నిశ్చయించిన",
  "Convincing": "ఆమోదయోగ్యంగా",
  "Good-Natured": "సుస్వభావము గలవాడు",
  "Friendly": "స్నేహశీలి",
  "Accurate": "ఖచ్చితమైన",
  "Outspoken": "నిష్కపటత",
  "Calm": "ప్రశాంతత",
  "Talkative": "మాటకారి",
  "Controlled": "నియంత్రిత",
  "Conventional": "సంప్రదాయకమైన",
  "Decisive": "నిర్ణయాత్మకం",
  "Adventurous": "సాహసముగల",
  "Insightful": "అంతర్దృష్టిగల",
  "Outgoing": "స్నేహపూర్వకమైన",
  "Moderate": "మితవాది",
  "Gentle": "మృదుస్వభావం",
  "Persuasive": "ఒప్పించగలిగే",
  "Humble": "వినయపూర్వకమైన",
  "Original": "అసలు",
  "Expressive": "వ్యక్తీకరణ",
  "Emotional": "భావోద్వేగ",
  "Dominant": "ఆధిపత్యం",
  "Responsible": "బాధ్యతాయుతంగా",
  "Self-Disciplined": "ఆత్మనిగ్రహం",
  "Observant": "పరిశీలకుడు",
  "Modest": "నిరాడంబరుడు",
  "Impatient": "సహనంలేని",
  "Tactful": "నేర్పుగల",
  "Agreeable": "అంగీకరించదగినది",
  "Magnetic": "ఆకర్షణీయమైన",
  "Insistent": "పట్టుబట్టి",
  "Brave": "ధైర్యశాలి",
  "Inspiring": "స్ఫూర్తిదాయకం",
  "Submissive": "లొంగిన",
  "Timid": "పిరికితనం",
  "Reserved": "మితభాషి",
  "Obliging": "ఉదార స్వభావం",
  "Strong Willed": "దృఢసంకల్పం",
  "Cheerful": "ఉల్లాసమైన",
  "Stimulating": "ప్రేరణనిచ్చే",
  "Kind": "కనికరముగల",
  "Perceptive": "గ్రహణశక్తిగల",
  "Independent": "స్వావలంబమైన",
  "Competitive": "పోటీపడగల",
  "Considerate": "వివేకముగల",
  "Joyful": "సంతోషకరమైన",
  "Private": "వ్యక్తిగత",
  "Fussy": "గందరగోళం",
  "Obedient": "విధేయుడైన",
  "Firm": "దృఢం",
  "Playful": "ఉల్లాసముగల",
  "Attractive": "ఆకర్షణీయ",
  "Introspective": "ఆత్మపరిశీలన",
  "Stubborn": "మొండియైన",
  "Predictable": "ఊహించదగిన",
  "Logical": "తార్కికమైన",
  "Bold": "నిర్భయం",
  "Loyal": "నమ్మకమైన",
  "Charming": "మనోహరమైన",
  "Sociable": "స్నేహశీలియైన",
  "Patient": "సహనశీలి",
  "Self Reliant": "స్వావలంబన",
  "Soft Spoken": "మృదుభాషి",
  "Willing": "ఇష్టపూర్వకంగా",
  "Eager": "తపన",
  "Thorough": "కూలంకషంగా",
  "High Spirited": "పరాక్రమం",
  "Aggressive": "దౌర్జన్యపూర్వక",
  "Extroverted": "బహిర్ముఖుడు",
  "Amiable": "స్నేహప్రద",
  "Fearful": "భయంకరమైన",
  "Confident": "ఆత్మవిశ్వాసం",
  "Sympathetic": "సానుభూతిగల",
  "Impartial": "నిష్పాక్షిక",
  "Assertive": "నొక్కిచెప్పడం",
  "Well-Disciplined": "సుశిక్షిత",
  "Generous": "ఉదారశీల",
  "Animated": "సజీవియైన",
  "Persistent": "పట్టుదలగల",
  "Impulsive": "హఠాత్తు",
  "Introverted": "అంతర్ముఖుడు",
  "Forceful": "శక్తివంతమైన",
  "Lenient": "ఉదారవైఖరి",
  "Good Mixer": "అందరితో కలిసిపోవడం",
  "Pure": "స్వచ్ఛమైన",
  "Alert": "చురుకైన",
  "Mild": "సౌమ్యమైన",
  "Captivating": "ఆకర్షకమైన",
  "Contented": "సంతోషముగానున్న",
  "Dominating": "దబాయింపు",
  "Complaining": "ఫిర్యాదు",
  "Argumentative": "వాదనశీలి",
  "Systematic": "క్రమబద్ధమైన",
  "Cooperative": "సహకారియైన",
  "Light-Hearted": "ఉల్లాసంగా ఉండే",
  "Jovial": "ఉల్లాసంగా",
  "Precise": "నిర్ధిష్టమైన",
  "Direct": "సూటియైన",
  "Even-Tempered": "శాంత స్వభావం",
  "Restless": "విరామములేని",
  "Neighbourly": "ఇరుగుపొరుగు",
  "Pleading": "విజ్ఞప్తి",
  "Careful": "జాగ్రత్త",
  "Respectful": "గౌరవభావంగల",
  "Pioneering": "మార్గదర్శి",
  "Optimistic": "ఆశావాది",
  "Helpful": "సహాయక"
}